export default __webpack_public_path__ + "static/media/chat_logo_fasting.2dc02041.svg";